<div *ngIf="isLoading$ | async" class="tab-spinner-container">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div *ngIf="(isLoading$ | async) === false && (teamsResult$ | async) as result">

  <ng-container *ngIf="result.data.length > 0; else noResultsTemplate">
    <mat-list role="list">
      <ng-container *ngFor="let team of result.data">
        <mat-list-item
          role="listitem"
          class="team-list-item"
          [routerLink]="['/statistics', statsMode === 'ia' ? 'team-ai' : 'team', team.id]">

          <mat-icon matListItemIcon>groups</mat-icon>
          <div matListItemTitle class="team-name">{{ team.name }}</div>
          <div matListItemLine class="team-meta">
            <span>{{ team.competition_name }}</span>
            <span *ngIf="team.category_name"> | {{ team.category_name }}</span>
            <span *ngIf="team.gender != null">
              | {{ team.gender == 0 ? 'Masculino' : team.gender == 1 ? 'Femenino' : team.gender == 2 ? 'Mixto' : 'No especificado'}}
            </span>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
      </ng-container>
    </mat-list>

    <mat-paginator
      *ngIf="result.total_results > result.page_size"
      [length]="result.total_results"
      [pageSize]="result.page_size"
      [pageIndex]="result.page - 1"
      (page)="handlePageEvent($event)"
      [showFirstLastButtons]="true"
      aria-label="Seleccionar página">
    </mat-paginator>
  </ng-container>

  <ng-template #noResultsTemplate>
    <div class="no-results-container">
      <mat-icon>search_off</mat-icon>
      <p>No se encontraron equipos para los filtros seleccionados.</p>
    </div>
  </ng-template>

</div>

<div *ngIf="(isLoading$ | async) === false && (teamsResult$ | async) === null" class="no-results-container">
  <mat-icon>filter_list</mat-icon>
  <p>
    {{ statsMode === 'ia'
      ? 'Selecciona filtros para iniciar la búsqueda IA. La temporada es opcional.'
      : 'Selecciona una Temporada y Competición para iniciar la búsqueda.' }}
  </p>
</div>
